import React from 'react'
import { PlaceholderWrapper, Placeholder } from '../GameBoardStyles'
import { CardWithBack } from '../../card/CardWithBack'
import { calculateDelay } from '../../card/helpers/calculateDelay'
import { colors } from '../../../lib/colors'

export default function Dealer({
  cardsList,
  deal,
  dealOut,
  flipCard,
  showResult,
  winPositions,
}: any) {
  return (
    <PlaceholderWrapper className='dealer'>
      {cardsList.map((card: any, id: any) => (
        <Placeholder key={id} zIndex={0}>
          <CardWithBack
            background={
              showResult && winPositions[id] === '1'
                ? colors.secondary
                : colors.cardWhite
            }
            card={card}
            deal={deal}
            flipCard={flipCard}
            dealOut={dealOut}
            animDelay={calculateDelay(id + 2)}
          />
        </Placeholder>
      ))}
    </PlaceholderWrapper>
  )
}
